import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Footer.css';

const Footer = () => {
  const formRef = useRef();
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setStatus('');

    // TODO: Replace these with your actual EmailJS credentials
    // 1. Sign up at https://www.emailjs.com/
    // 2. Create an email service (e.g., Gmail)
    // 3. Create an email template with variables: {{from_name}}, {{from_email}}, {{phone}}, {{message}}
    // 4. Replace the IDs below
    emailjs
      .sendForm(
        'YOUR_SERVICE_ID',   // e.g., 'service_abc123'
        'YOUR_TEMPLATE_ID',  // e.g., 'template_xyz789'
        formRef.current,
        'YOUR_PUBLIC_KEY'    // e.g., 'aBcDeFgHiJkLmNoP'
      )
      .then(
        () => {
          setStatus('success');
          setSending(false);
          formRef.current.reset();
        },
        () => {
          setStatus('error');
          setSending(false);
        }
      );
  };

  return (
    <footer className="footer" id="contact">
      <div className="container footer-grid">
        {/* Company Info */}
        <div className="footer-col">
          <div className="footer-logo">
            <img src="/Logo.png" alt="Rajmaya Group" className="footer-logo-img" />
            <h3 className="footer-logo-text">Rajmaya<span>Group</span></h3>
          </div>
          <p>
            Building trust through quality construction since 2015. Your vision,
            our expertise.
          </p>
        </div>

        {/* Contact Details */}
        <div className="footer-col">
          <h4>Contact Us</h4>
          <ul className="contact-list">
            <li>📍 123, Main Road, City, State - 000000</li>
            <li>📞 +91 98765 43210</li>
            <li>📧 info@rajmayagroup.com</li>
            <li>🕐 Mon - Sat: 9:00 AM - 6:00 PM</li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#projects">Projects</a></li>
          </ul>
        </div>

        {/* Enquiry Form */}
        <div className="footer-col enquiry">
          <h4>Send an Enquiry</h4>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input type="text" name="from_name" placeholder="Your Name" required />
            <input type="email" name="from_email" placeholder="Your Email" required />
            <input type="tel" name="phone" placeholder="Your Phone" />
            <textarea name="message" rows="3" placeholder="Your Message" required />
            <button type="submit" className="btn btn-submit" disabled={sending}>
              {sending ? 'Sending...' : 'Send Enquiry'}
            </button>
          </form>
          {status === 'success' && (
            <p className="form-note success">Enquiry sent successfully!</p>
          )}
          {status === 'error' && (
            <p className="form-note error">Failed to send. Please try again.</p>
          )}
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 Rajmaya Group. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
